<mat-card appearance="outlined" class="user-summary-page">
  <mat-card-title>Database > Groupe : {{selectedGroup.group}}@if (dataSource) {
    <span
    >({{dataSource.length}})</span>
  }</mat-card-title>
  <mat-card-actions align="end">

  </mat-card-actions>
  <mat-card-content>
    <div class="resume_" fxLayout="row wrap" fxCols="2" fxLayoutAlign="start start" fxLayoutGap="5% grid">
      @if (!loading) {
        <div class="datatable">
          <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
            @for (group of user_groups; track group) {
              <mat-tab [label]="group">{{group}}</mat-tab>
            }
          </mat-tab-group>
          <table mat-table [dataSource]="dataSource" matSort matSortActive="created" matSortDisableClear
            matSortDirection="asc" matTableResponsive>
            <ng-container matColumnDef="DBInstanceStatus">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-stretch-l">État</th>
              <td mat-cell *matCellDef="let resource; let index = index" class="col-stretch-l">
                <span class="resource-state" [ngClass]="getDisplayedResourceState(resource)" role="status" aria-live="polite">
                  <mat-icon aria-hidden="true">{{getResourceStateDesc(getDisplayedResourceState(resource))?.icon}}</mat-icon>
                  <span>{{getResourceStateLabel(getDisplayedResourceState(resource))}}</span>
                </span>
              </td>
            </ng-container>
            @for (header of displayedColumns.slice(1).slice(0, -1); track header) {
              <ng-container
                matColumnDef="{{header}}">
                <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear="true">
                  {{displayedColumnsName[displayedColumns.indexOf(header)]}}
                </th>
                <td mat-cell *matCellDef="let resource" class="col-stretch-xl">
                  {{ resource[header]}}
                </td>
              </ng-container>
            }
            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let resource">
                @for (action of getApplicableActions(resource); track action) {
                  @if (action.name === 'start') {
                    <button mat-icon-button [color]="action.color"
                      class="btn btn-link btn-info btn-just-icon "
                      (click)="startInstance($event, resource)"><i
                    class="material-icons">{{action.icon}}</i></button>
                  }
                  @if (action.name === 'stop') {
                    <button mat-icon-button [color]="action.color"
                      class="btn btn-link btn-info btn-just-icon "
                      (click)="stopInstance($event, resource)"><i
                    class="material-icons">{{action.icon}}</i></button>
                  }
                }
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row class="caaks-detail-row"
            *matRowDef="let row; columns: displayedColumns; let index = index"></tr>
          </table>
          <!--<caaks-datatable *ngIf="dataSource && dataSource.length > 0" [options]="tableOptions"
          [dataSource]="dataSource" [headerCols]="displayedColumns"
        [rowActions]="[{icon: 'play_circle', handler: startInstance, condition: isInstanceRunning}]"></caaks-datatable>-->
        @if (dataSource && dataSource.length === 0) {
          <p>Aucune données.</p>
        }
      </div>
    } @else {
                <div style="display: flex;
                padding: 0px 5% 5% 0px;
                flex-direction: row;
                flex-wrap: nowrap;
                justify-content: flex-start;
                align-items: center;"><mat-spinner [diameter]="40"></mat-spinner> <span
        style="margin-left: 10px;">Chargement des
      données...</span></div>
    }

  </div>


</mat-card-content>
</mat-card>